import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=fc13916a"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=fc13916a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports